import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import kominfoLogin from '../assets/kominfo-login.png';
import leftArrow from '../assets/left-arrow.svg';
import organizer from '../assets/penyelenggara-sertifikat-elektronik.png';

export default class Login extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 px-0 d-lg-block d-md-block d-sm-none d-none">
          <div className="carousel slide" id="carousel-sign-up" data-ride="carousel">
            <ol className="carousel-indicators">
              <li className="active" data-target="#carousel-sign-up" data-slide-to="0"></li>
              <li data-target="#carousel-sign-up" data-slide-to="1"></li>
              <li data-target="#carousel-sign-up" data-slide-to="2"></li>
            </ol>
            <div className="carousel-inner">
              <div className="carousel-item active">
                <Link className="back-to-home" to='/' style={{color: 'white'}}>
                  <div className="circle"><img src={leftArrow} alt="left-arrow" style={{width: '18px', height: '18px'}} /></div><span className="ml-3 mt-2" style={{fontSize: '14px'}}>Kembali</span>
                </Link>
                <img src={kominfoLogin} alt="e-fishery-owner" style={{height: '100vh', width: '100%', objectFit: 'cover'}} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-md-6 col-sm-12 col-12 px-0">
          <div className="center mx-auto">
            <div className="col-lg-7 col-md-9 col-sm-10 col-10 mx-auto px-0">
              <Link to='/' style={{color: 'white'}}>
                <img className="d-block mx-auto mb-5" src={organizer}alt="penyelenggara-sertifikat-elektronik" style={{height: '50px', width: 'auto'}} />
              </Link>
                {this.props.children}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
